import { render, staticRenderFns } from "./UploadDocumentHistoryTable.vue?vue&type=template&id=7e2be490&"
import script from "./UploadDocumentHistoryTable.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports